import React, { useCallback, useMemo } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { parse } from 'query-string';

import Login from '../containers/login/login';
import Logout from '../containers/logout/logout';
import Callback from '../containers/callback';
import Message from '../containers/message';
import { MessageProps } from '../containers/message/types';

const Routes: React.FC = () => {
  const params = useMemo(() => parse(location.search), [location]);
  const renderMessage = useCallback(() => {
    let props: MessageProps;
    switch (params.id) {
      case 'em-analise':
        props = {
          traductionKey: "registration_in_analysis",
          image: "profile",
        };
        break;
      case 'tentar-de-novo':
        props = {
          traductionKey: "try_again",
          image: "profile",
          secondaryLink: "/recuperar/senha",
        };
        break;
      case 'legado':
        props = {
          traductionKey: "legacy_number",
          traductionContentParams: { memberNumber: params.memberNumber },
          image:"profile",
          primaryLink: "/home",
        };
        break;
      default:
        props = {};
        break;
    }
    return <Message {...props} />
  }, [params]);

  return (
    <div className="vbz-lf">
      <Router>
        <Switch>
          <Route exact path="/validar" component={Callback} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/logout" component={Logout} />
          <Route exact path="/validar/erro" component={Message} />
          <Route exact path="/validar/mensagem" render={renderMessage} />
          <Redirect to="/home" />
        </Switch>
      </Router>
    </div>
  );
};

export default Routes;
